import { ReactElement } from 'react';

import { DashboardVariantV2GiverContentActionsContainer } from '../../../../styles';

import DashboardVariantV2GiverContentInTransitTabActionsFilters from './Filters';
import DashboardVariantV2GiverContentInTransitTabActionsActionables from './Actionables';

const DashboardVariantV2GiverContentInTransitTabActions = (): ReactElement => {
  return (
    <DashboardVariantV2GiverContentActionsContainer justifyContent="space-between">
      <DashboardVariantV2GiverContentInTransitTabActionsFilters />

      <DashboardVariantV2GiverContentInTransitTabActionsActionables />
    </DashboardVariantV2GiverContentActionsContainer>
  );
};

export default DashboardVariantV2GiverContentInTransitTabActions;
